import React, { useState, useEffect } from 'react';

const Button = ({text, clickHandler}) => (
    <div className="selection-button" onClick={clickHandler}>
        <p>{text}</p>
       <div className="gradient-cover"></div>
    </div>
)

export default Button;